/* eslint-disable */
export default {
  downloadSuccess: 'Registro scaricato.',
  downloadFail: 'Download registro errori non riuscito. Riprova.',
} as const;

// @key: @#@"downloadSuccess"@#@ @source: @#@"Log downloaded."@#@
// @key: @#@"downloadFail"@#@ @source: @#@"Error log download failed. Please try again."@#@
